export default __webpack_public_path__ + "static/media/kashmir.db7c9f3b.jpg";